// Presentation helpers for the SDK's SessionInfo shape (os / osVersion /
// deviceFamily / browser / city / country). Kept in one place so the sessions
// table and the session-info modal classify and label devices identically.

const haystack = (session) =>
    [
        session?.os,
        session?.deviceFamily,
        session?.browser,
        session?.clientId,
    ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();

const isFingoti = (session) => haystack(session).includes('fingoti');

const isWindows = (session) => haystack(session).includes('windows');

const isAndroid = (session) => haystack(session).includes('android');

const isApple = (session) => {
    const h = haystack(session);
    return (
        h.includes('ios') ||
        h.includes('ipad') ||
        h.includes('iphone') ||
        h.includes('mac')
    );
};

// "Windows 11", "Android 14", etc. Falls back to "Unknown" when the server
// captured no OS for the session (e.g. some backend clients).
const platformLabel = (session) => {
    const label = [session?.os, session?.osVersion].filter(Boolean).join(' ');
    return label || 'Unknown';
};

const location = (session) => {
    const label = [session?.city, session?.country].filter(Boolean).join(', ');
    return label || 'Unknown';
};

export const sessionService = {
    isFingoti,
    isWindows,
    isAndroid,
    isApple,
    platformLabel,
    location,
};
